import { Badge } from '@/components/shadcn/badge'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconAccountConvertOutline } from '@icons/IconAccountConvertOutline'
import { IconCommunityOutline } from '@icons/IconCommunityOutline'
import { ColumnDef } from '@tanstack/react-table'
// import clsx from 'clsx'
import { Link } from 'react-router'
// import { statusBadge } from '../ApllicationsGridItem'
import { CardActionsMenu } from '../CardActionsMenu'
import { ApplicationLink } from './ApplicationLink'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { deriveAppTypesNamesFromAppTypesNumber } from '@/util/appTypes'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export const columns: ColumnDef<MessagesApplicationsApplication>[] = [
  {
    id: 'appName',
    accessorFn: (row) => `${row.appName} ${row.description}`,
    header: ({ column }) => <SortingHeaderButton column={column}>Application</SortingHeaderButton>,
    cell: ({ row }) => <ApplicationLink item={row.original} />,
    sortingFn: (rowA, rowB) => rowA.original.appName.localeCompare(rowB.original.appName),
    size: 250,
  },
  {
    id: 'appKey',
    accessorKey: 'appKey',
    header: ({ column }) => <SortingHeaderButton column={column}>Key</SortingHeaderButton>,
    cell: ({ cell }) => (
      <Badge variant="outline" className="font-normal">
        {cell.getValue() as string}
      </Badge>
    ),
    sortingFn: (rowA, rowB) => rowA.original.appKey.localeCompare(rowB.original.appKey),
  },
  {
    id: 'appTypes',
    accessorKey: 'appTypes',
    header: 'App Types',
    cell: ({ cell }) => {
      const appTypes = deriveAppTypesNamesFromAppTypesNumber(cell.getValue() as number)
      return (
        <div className="flex flex-row flex-wrap gap-1">
          {appTypes.map((appType) => (
            <Badge key={appType} variant="outline" className="whitespace-nowrap font-normal">
              {appType}
            </Badge>
          ))}
        </div>
      )
    },
  },
  {
    id: 'status',
    accessorKey: 'status',
    header: 'Status',
    cell: ({ cell }) => (
      // <Badge
      //   className={clsx(
      //     'h-4 w-fit font-normal',
      //     statusBadge[cell.getValue() as keyof typeof statusBadge] || 'bg-grey-50 text-grey-700 border-grey-700'
      //   )}
      // >
      //   {cell.getValue() as string}
      // </Badge>
      <Badge
        className="h-4 w-fit font-bold"
        variant={cell.getValue() === 'Live' ? 'success' : cell.getValue() === 'Developing' ? 'warning' : 'error'}
      >
        {cell.getValue() as string}
      </Badge>
    ),
  },
  {
    id: 'roleCount',
    // accessorKey: 'roleCount',
    header: 'Roles',
    cell: ({ row }) => (
      <Link
        to={`${row.original.appKey}/roles`}
        // className={clsx('text-muted-foreground')}
        className="group flex items-center gap-x-2 p-1.5 text-muted-foreground"
      >
        <IconAccountConvertOutline className="size-5" />
        <NumberBadge value={row.original.roleCount} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'appTeamCount',
    // accessorKey: 'appTeamCount',
    header: 'Teams',
    cell: ({ row }) => (
      <Link
        // className={buttonVariants({ variant: 'outline', size: 'sm' })}
        to={`${row.original.appKey}/teams`}
        className="group flex items-center gap-x-2 p-1.5 text-muted-foreground"
      >
        <IconCommunityOutline className="size-4" />
        <NumberBadge value={row.original.appTeamCount} />
        <IconOpenInNewOutline className="ml-5 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </Link>
    ),
  },
  {
    id: 'actions',
    // header: 'Actions',
    cell: ({ row }) => (
      <div className="flex justify-end pr-5">
        <CardActionsMenu app={row.original} />
      </div>
    ),
  },
]
